// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { HTTPClient } from "./client";

export type { APIConfig } from "./client";
export type { FetchParams } from "./core";
export { APIError, SumUpError } from "./core";
export * from "./resources/checkouts";
export * from "./types";

import { Checkouts } from "./resources/checkouts";

export * from "./resources/customers";

import { Customers } from "./resources/customers";

export * from "./resources/members";

import { Members } from "./resources/members";

export * from "./resources/memberships";

import { Memberships } from "./resources/memberships";

export * from "./resources/merchant";

import { MerchantResource } from "./resources/merchant";

export * from "./resources/merchants";

import { Merchants } from "./resources/merchants";

export * from "./resources/payouts";

import { Payouts } from "./resources/payouts";

export * from "./resources/readers";

import { Readers } from "./resources/readers";

export * from "./resources/receipts";

import { Receipts } from "./resources/receipts";

export * from "./resources/roles";

import { Roles } from "./resources/roles";

export * from "./resources/subaccounts";

import { Subaccounts } from "./resources/subaccounts";

export * from "./resources/transactions";

import { Transactions } from "./resources/transactions";

export class SumUp extends HTTPClient {
  checkouts: Checkouts = new Checkouts(this);
  customers: Customers = new Customers(this);
  members: Members = new Members(this);
  memberships: Memberships = new Memberships(this);
  merchant: MerchantResource = new MerchantResource(this);
  merchants: Merchants = new Merchants(this);
  payouts: Payouts = new Payouts(this);
  readers: Readers = new Readers(this);
  receipts: Receipts = new Receipts(this);
  roles: Roles = new Roles(this);
  subaccounts: Subaccounts = new Subaccounts(this);
  transactions: Transactions = new Transactions(this);
}

export default SumUp;
